import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { StripeGenericPayForm } from './StripeGenericPayForm';

export const P24PayForm = () => {
  const { paymentMethodsSettings } = useContext(CheckoutContext);
  const providerSettings = paymentMethodsSettings.find(
    (paymentMethod) => paymentMethod.paymentMethodName === PaymentMethodEnum.P24
  );

  if (providerSettings?.provider === ProviderEnum.STRIPE) {
    return <StripeGenericPayForm paymentMethod="p24" />;
  }

  return null;
};
